/**
 * "A new version is ready."
 *
 * Asked rather than applied. A reload the user did not ask for is a reload in the middle of a
 * sentence they were typing — and while the journal means nothing would actually be lost, being
 * interrupted by software that decided for you is its own kind of damage.
 *
 * Dismissing does not lose the update: it is already downloaded, and it applies the next time the
 * application is opened. Saying so is what makes dismissing a real option rather than a delay.
 */
import { useEffect, useState } from 'react';

import { applyUpdate, onUpdateReady } from '../pwa';
import { Button, IconButton } from './controls';
import { IconClose } from './icons';

export function UpdateBanner(): React.JSX.Element | null {
  const [ready, setReady] = useState(false);
  const [dismissed, setDismissed] = useState(false);

  useEffect(
    () =>
      onUpdateReady(() => {
        setReady(true);
      }),
    [],
  );

  if (!ready || dismissed) return null;

  return (
    <div
      role="status"
      className="border-edge bg-surface rounded-panel animate-rise-in pb-safe fixed inset-x-3 bottom-3 z-50 flex items-center gap-3 border p-3 shadow-2xl sm:right-4 sm:bottom-4 sm:left-auto sm:max-w-sm"
    >
      <div className="min-w-0 flex-1">
        <p className="text-sm font-medium">A new version is ready.</p>
        <p className="text-ink-muted mt-0.5 text-xs">
          It will be used next time you open Orbit Mind, or you can reload now.
        </p>
      </div>
      <Button tone="primary" size="sm" onClick={applyUpdate}>
        Reload
      </Button>
      <IconButton
        label="Dismiss"
        icon={<IconClose size={16} />}
        size="sm"
        onClick={() => {
          setDismissed(true);
        }}
      />
    </div>
  );
}
